<!--
 * @Author: mazhigang
 * @Date: 2023-07-03 17:43:22
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-01-31 13:15:14
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>平台设置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch"></div>
      <div class="pageTab">
        <div class="boxItem">
          <el-form ref="ruleForm" :model="ruleForm" style="width: 100%">
            <el-form-item
              label="保安审核方式"
              style="margin-bottom: 0 !important"
            >
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <div style="display: flex; margin: 0 40px 0">
                  <el-select
                    v-model="ruleForm.radio"
                    placeholder="请选择审核方式"
                    :disabled="isEdit7"
                  >
                    <el-option
                      :label="item.title"
                      :value="item.id"
                      v-for="(item, index) in radioList"
                      :key="index"
                    ></el-option>
                  </el-select>
                </div>
                <div>
                  <div
                    style="color: blue; cursor: pointer"
                    v-if="isEdit7"
                    @click="edit(7)"
                  >
                    编辑
                  </div>
                  <div>
                    <el-button
                      v-if="!isEdit7"
                      @click="close(7)"
                      style="margin: 0 auto; background: #fff; color: #000"
                      class="btn"
                      >取消</el-button
                    >
                    <el-button
                      v-if="!isEdit7"
                      @click="submitForm(7)"
                      class="btn"
                      style="margin: 0 auto"
                      >保存</el-button
                    >
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="boxItem">
          <el-form ref="ruleForm" :model="ruleForm" style="width: 100%">
            <el-form-item
              label="用户端提现费率（%）"
              style="margin-bottom: 0 !important"
            >
              <div style="display: flex; justify-content: space-between">
                <div style="display: flex">
                  <el-input
                    style="width: 80%"
                    maxlength="50"
                    type="number"
                    clearable
                    :disabled="isEdit0"
                    v-model="ruleForm.customWithdraw.range"
                    placeholder="请输入百分比"
                    ><template slot="append">%</template>
                  </el-input>
                </div>
                <div>
                  <div
                    style="color: blue; cursor: pointer"
                    v-if="isEdit0"
                    @click="edit(0)"
                  >
                    编辑
                  </div>
                  <div>
                    <el-button
                      v-if="!isEdit0"
                      @click="close(0)"
                      style="margin: 0 auto; background: #fff; color: #000"
                      class="btn"
                      >取消</el-button
                    >
                    <el-button
                      v-if="!isEdit0"
                      @click="submitForm(0)"
                      class="btn"
                      style="margin: 0 auto"
                      >保存</el-button
                    >
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="boxItem">
          <el-form ref="ruleForm" :model="ruleForm">
            <el-form-item
              label="保安端提现费率（%）"
              style="margin-bottom: 0 !important"
            >
              <div style="display: flex; justify-content: space-between">
                <div style="display: flex">
                  <el-input
                    style="width: 80%"
                    maxlength="50"
                    clearable
                    :disabled="isEdit"
                    type="number"
                    v-model="ruleForm.bodyguardWithdraw.range"
                    placeholder="请输入百分比"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </div>
                <div>
                  <div
                    style="color: blue; cursor: pointer"
                    v-if="isEdit"
                    @click="edit(1)"
                  >
                    编辑
                  </div>
                  <el-button
                    v-if="!isEdit"
                    @click="close(1)"
                    style="margin: 0 auto; background: #fff; color: #000"
                    class="btn"
                    >取消</el-button
                  >
                  <el-button
                    v-if="!isEdit"
                    @click="submitForm(1)"
                    class="btn"
                    style="margin: 0 auto"
                    >保存</el-button
                  >
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="boxItem">
          <el-form ref="ruleForm" :model="ruleForm">
            <el-form-item
              label="用户钱包退款设置（元）"
              style="margin-bottom: 0 !important"
            >
              <div style="display: flex; justify-content: space-between">
                <div>
                  <el-input
                    style="width: 40%"
                    maxlength="50"
                    clearable
                    :disabled="isEdit5"
                    type="number"
                    v-model="ruleForm.customWithdraw.min"
                    placeholder="请输入最小金额"
                  ></el-input>
                  <span>-</span>
                  <el-input
                    style="width: 40%"
                    maxlength="50"
                    clearable
                    :disabled="isEdit5"
                    type="number"
                    v-model="ruleForm.customWithdraw.max"
                    placeholder="请输入最大金额"
                  ></el-input>
                </div>
                <div>
                  <div
                    style="color: blue; cursor: pointer"
                    v-if="isEdit5"
                    @click="edit(5)"
                  >
                    编辑
                  </div>
                  <el-button
                    v-if="!isEdit5"
                    @click="close(5)"
                    style="margin: 0 auto; background: #fff; color: #000"
                    class="btn"
                    >取消</el-button
                  >
                  <el-button
                    v-if="!isEdit5"
                    @click="submitForm(5)"
                    class="btn"
                    style="margin: 0 auto"
                    >保存</el-button
                  >
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="boxItem">
          <el-form ref="ruleForm" :model="ruleForm">
            <el-form-item
              label="保安钱包提现设置（元）"
              style="margin-bottom: 0 !important"
            >
              <div style="display: flex; justify-content: space-between">
                <div>
                  <el-input
                    style="width: 40%"
                    maxlength="50"
                    clearable
                    :disabled="isEdit6"
                    type="number"
                    v-model="ruleForm.bodyguardWithdraw.min"
                    placeholder="请输入最小金额"
                  ></el-input>
                  <span>-</span>
                  <el-input
                    style="width: 40%"
                    maxlength="50"
                    clearable
                    :disabled="isEdit6"
                    type="number"
                    v-model="ruleForm.bodyguardWithdraw.max"
                    placeholder="请输入最大金额"
                  ></el-input>
                </div>
                <div>
                  <div
                    style="color: blue; cursor: pointer"
                    v-if="isEdit6"
                    @click="edit(6)"
                  >
                    编辑
                  </div>
                  <el-button
                    v-if="!isEdit6"
                    @click="close(6)"
                    style="margin: 0 auto; background: #fff; color: #000"
                    class="btn"
                    >取消</el-button
                  >
                  <el-button
                    v-if="!isEdit6"
                    @click="submitForm(6)"
                    class="btn"
                    style="margin: 0 auto"
                    >保存</el-button
                  >
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="boxItem">
          <el-form ref="ruleForm" :model="ruleForm">
            <el-form-item
              label="接单类型设置"
              style="margin-bottom: 0 !important"
            >
              <div style="display: flex; justify-content: space-between">
                <el-select
                  v-model="ruleForm.type"
                  placeholder="请选择接单类型"
                  :disabled="isEdit1"
                >
                  <el-option
                    :label="item.title"
                    :value="item.id"
                    v-for="(item, index) in list"
                    :key="index"
                  ></el-option>
                </el-select>
                <div>
                  <div
                    style="color: blue; cursor: pointer; margin-left: 40px"
                    v-if="isEdit1"
                    @click="edit(2)"
                  >
                    编辑
                  </div>
                  <el-button
                    v-if="!isEdit1"
                    @click="close(2)"
                    style="margin: 0 auto; background: #fff; color: #000"
                    class="btn"
                    >取消</el-button
                  >
                  <el-button
                    v-if="!isEdit1"
                    @click="submitForm(2)"
                    class="btn"
                    style="margin: 0 auto"
                    >保存</el-button
                  >
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="boxItem">
          <div>
            <el-form ref="ruleForm" :model="ruleForm">
              <el-form-item
                label="接单范围"
                style="margin-bottom: 0 !important"
              >
                <div style="display: flex; justify-content: space-between">
                  <div style="display: flex; align-items: center">
                    <el-select
                      v-model="ruleForm.region"
                      placeholder="请选择接单范围"
                      :disabled="isEdit2"
                    >
                      <el-option
                        :label="item.title"
                        :value="item.id"
                        v-for="(item, index) in range"
                        :key="index"
                      ></el-option>
                    </el-select>
                    <div v-if="ruleForm.region == '3'">
                      <el-input
                        style="width: 40%; margin-left: 70px"
                        maxlength="50"
                        clearable
                        type="number"
                        :disabled="isEdit2"
                        v-model="ruleForm.num1"
                        placeholder="请填写接单范围，如5表示5公里"
                      ></el-input>
                      <div
                        style="font-size: 12px; flex: none; margin-left: 70px"
                      >
                        请填写接单范围，如5表示5公里
                      </div>
                    </div>
                  </div>
                  <div>
                    <div
                      style="color: blue; cursor: pointer; margin-left: 40px"
                      v-if="isEdit2"
                      @click="edit(3)"
                    >
                      编辑
                    </div>
                    <el-button
                      v-if="!isEdit2"
                      @click="close(3)"
                      style="margin: 0 auto; background: #fff; color: #000"
                      class="btn"
                      >取消</el-button
                    >
                    <el-button
                      v-if="!isEdit2"
                      @click="submitForm(3)"
                      class="btn"
                      style="margin: 0 auto"
                      >保存</el-button
                    >
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="boxItem">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <div class="boxTitle">对公打款信息</div>
            <div>
              <div
                style="color: blue; cursor: pointer"
                v-if="isEdit3"
                @click="edit(4)"
              >
                编辑
              </div>
              <el-button
                v-if="!isEdit3"
                @click="close(4)"
                style="margin: 0 auto; background: #fff; color: #000"
                class="btn"
                >取消</el-button
              >
              <el-button
                v-if="!isEdit3"
                @click="submitForm(4)"
                class="btn"
                style="margin: 0 auto"
                >保存</el-button
              >
            </div>
          </div>
          <div>
            <el-form ref="ruleForm" :model="ruleForm">
              <el-form-item label="公司名称">
                <el-input
                  style="width: 40%"
                  maxlength="50"
                  clearable
                  :disabled="isEdit3"
                  v-model="ruleForm.name"
                  placeholder="请输入公司名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="开户行名称">
                <el-input
                  style="width: 40%"
                  maxlength="50"
                  :disabled="isEdit3"
                  clearable
                  v-model="ruleForm.bankName"
                  placeholder="请输入开户行名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="银行地址">
                <el-input
                  style="width: 40%"
                  maxlength="50"
                  :disabled="isEdit3"
                  clearable
                  v-model="ruleForm.bankAddress"
                  placeholder="请输入银行地址"
                ></el-input>
              </el-form-item>
              <el-form-item label="银行卡号">
                <el-input
                  style="width: 40%"
                  :disabled="isEdit3"
                  maxlength="50"
                  clearable
                  v-model="ruleForm.bankNum"
                  placeholder="请输入银行卡号"
                ></el-input>
              </el-form-item>
              <el-form-item label="备注信息">
                <el-input
                  style="width: 40%"
                  maxlength="50"
                  :disabled="isEdit3"
                  clearable
                  v-model="ruleForm.notes"
                  placeholder="请输入备注信息"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.systemData(),
      ruleForm: {
        bankName: "",
        bankAddress: "",
        name: "",
        bankNum: "",
        notes: "",
        num1: "",
        region: "",
        type: "",
        radio: "",
        customWithdraw: {
          max: "",
          min: "",
          range: "",
        },
        bodyguardWithdraw: {
          max: "",
          min: "",
          range: "",
        },
      },
      key: "pricePremiumType_orderlimit",
      isEdit: true,
      isEdit0: true,
      isEdit1: true,
      isEdit2: true,
      isEdit3: true,
      isEdit5: true,
      isEdit6: true,
      isEdit7: true,
      range: [],
      list: [],
      id0: "",
      id1: "",
      id2: "",
      id3: "",
      id4: "",
      id5: "",
      id6: "",
      id7: "",
      radioList: [],
    };
  },
  mounted() {
    this.getList();
    this.getList1();
    this.getList2();
    this.getList5();
    this.getList6();
    this.getList7();
  },
  methods: {
    close(val) {
      if (val == 1) {
        this.isEdit = !this.isEdit;
        this.getList6();
      } else if (val == 2) {
        this.isEdit1 = !this.isEdit1;
        this.getList2();
      } else if (val == 3) {
        this.isEdit2 = !this.isEdit2;
        this.getList();
      } else if (val == 4) {
        this.isEdit3 = !this.isEdit3;
        this.getList1();
      } else if (val == 0) {
        this.isEdit0 = !this.isEdit0;
        this.getList5();
      } else if (val == 5) {
        this.isEdit5 = !this.isEdit5;
        this.getList5();
      } else if (val == 6) {
        this.isEdit6 = !this.isEdit6;
        this.getList6();
      } else if (val == 7) {
        this.isEdit7 = !this.isEdit7;
        this.getList7();
      }
    },
    edit(val) {
      if (val == 1) {
        this.isEdit = !this.isEdit;
      } else if (val == 2) {
        this.isEdit1 = !this.isEdit1;
      } else if (val == 3) {
        this.isEdit2 = !this.isEdit2;
      } else if (val == 4) {
        this.isEdit3 = !this.isEdit3;
      } else if (val == 0) {
        this.isEdit0 = !this.isEdit0;
      } else if (val == 5) {
        this.isEdit5 = !this.isEdit5;
      } else if (val == 6) {
        this.isEdit6 = !this.isEdit6;
      } else if (val == 7) {
        this.isEdit7 = !this.isEdit7;
      }
    },
    submitForm(formName) {
      let key = "";
      let param = {};
      let id = "";
      // 提交用户端提现费率
      if (formName == 0 || formName == 5) {
        key = "customWithdrawConfigKey";
        id = this.id0;
        let obj = this.ruleForm.customWithdraw;
        console.log(obj);
        if (formName == 5) {
          if (obj.min * 1 < 1) {
            this.$message({
              message: "用户钱包退款最小金额不能小于1",
              type: "warning",
            });
            return;
          }
          if (obj.max * 1 < 1) {
            this.$message({
              message: "用户钱包退款最大金额不能小于1",
              type: "warning",
            });
            return;
          }
          if (obj.max * 1 <= obj.min * 1) {
            this.$message({
              message: "用户钱包退款最大金额必须大于最小金额",
              type: "warning",
            });
            return;
          }
        }
        obj.range = (obj.range * 1) / 100;
        param = {
          propName: key,
          propValue: JSON.stringify(obj),
        };
      }
      // 提交保安端提现费率
      if (formName == 1 || formName == 6) {
        key = "bodyguardWithdrawConfigKey";
        id = this.id1;
        let obj = this.ruleForm.bodyguardWithdraw;
        if (formName == 6) {
          if (obj.min * 1 < 1) {
            this.$message({
              message: "保安钱包提现最小金额不能小于1",
              type: "warning",
            });
            return;
          }
          if (obj.max * 1 < 1) {
            this.$message({
              message: "保安钱包提现最大金额不能小于1",
              type: "warning",
            });
            return;
          }
          if (obj.max * 1 <= obj.min * 1) {
            this.$message({
              message: "保安钱包提现最大金额必须大于最小金额",
              type: "warning",
            });
            return;
          }
        }
        obj.range = (obj.range * 1) / 100;
        param = {
          propName: key,
          propValue: JSON.stringify(obj),
        };
      }
      // 提交接单类型
      if (formName == 2) {
        key = "taskApplyType";
        id = this.id2;
        param = {
          propName: key,
          propValue: this.ruleForm.type,
        };
      }
      // 提交保安接单范围
      if (formName == 3) {
        key = "pricePremiumType_orderlimit";
        id = this.id3;
        if (this.ruleForm.region == "3") {
          if (this.ruleForm.num1 == "") {
            this.$message({
              message: "请填写接单范围",
              type: "warning",
            });
            return;
          }
          if (this.ruleForm.num1 == 0) {
            this.$message({
              message: "接单范围必须大于0",
              type: "warning",
            });
            return;
          }
          param = {
            propName: key,
            propValue: JSON.stringify({
              id: this.ruleForm.region,
              value: this.ruleForm.num1,
            }),
          };
        } else {
          param = {
            propName: key,
            propValue: JSON.stringify({
              id: this.ruleForm.region,
              value: "0",
            }),
          };
        }
      }
      // 提交对公打款信息
      if (formName == 4) {
        key = "paymentInfo";
        id = this.id4;
        let obj = {
          bankName: this.ruleForm.bankName,
          bankArea: this.ruleForm.bankAddress,
          cardNumber: this.ruleForm.bankNum,
          companyName: this.ruleForm.name,
          remark: this.ruleForm.notes,
        };
        param = {
          propName: key,
          propValue: JSON.stringify(obj),
        };
      }
      // 提交保安审核信息
      if (formName == 7) {
        key = "bodyguardAuthAutoPower";
        id = this.id7;
        param = {
          propName: key,
          propValue: this.ruleForm.radio,
        };
      }
      this.$axios
        .post(`/admapi/sys/conf/update/${id}`, param)
        .then(({ data }) => {
          this.$message({
            message: "编辑成功",
            type: "success",
          });
          if (formName == 1) {
            this.isEdit = !this.isEdit;
            this.getList6();
          } else if (formName == 2) {
            this.isEdit1 = !this.isEdit1;
            this.getList2();
          } else if (formName == 3) {
            this.isEdit2 = !this.isEdit2;
            this.getList();
          } else if (formName == 4) {
            this.isEdit3 = !this.isEdit3;
            this.getList1();
          } else if (formName == 0) {
            this.isEdit0 = !this.isEdit0;
            this.getList5();
          } else if (formName == 5) {
            this.isEdit5 = !this.isEdit5;
            this.getList5();
          } else if (formName == 6) {
            this.isEdit6 = !this.isEdit6;
            this.getList6();
          } else if (formName == 7) {
            this.isEdit7 = !this.isEdit7;
            this.getList7();
          }
        })
        .catch()
        .finally(() => {});
    },
    // 获取保安接单范围
    getList() {
      let param = {
        page: 1,
        pageSize: 99999,
        queryParams: [
          {
            name: "prop_name",
            type: "input",
            value: "pricePremiumType_orderlimit",
          },
        ],
      };
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          this.range = JSON.parse(data.items[0].propDesc);
          this.ruleForm.region = JSON.parse(data.items[0].propValue).id;
          this.ruleForm.num1 = JSON.parse(data.items[0].propValue).value;
          this.id3 = data.items[0].id;
        })
        .catch()
        .finally();
    },
    //获取对公打款信息
    getList1() {
      let param = {
        page: 1,
        pageSize: 99999,
        queryParams: [
          {
            name: "prop_name",
            type: "input",
            value: "paymentInfo",
          },
        ],
      };
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          let info = JSON.parse(data.items[0].propValue);
          this.$set(this.ruleForm, "name", info.companyName);
          this.$set(this.ruleForm, "bankName", info.bankName);
          this.$set(this.ruleForm, "bankAddress", info.bankArea);
          this.$set(this.ruleForm, "bankNum", info.cardNumber);
          this.$set(this.ruleForm, "notes", info.remark);
          this.id4 = data.items[0].id;
        })
        .catch()
        .finally();
    },
    // 获取接单类型
    getList2() {
      let param = {
        page: 1,
        pageSize: 99999,
        queryParams: [
          {
            name: "prop_name",
            type: "input",
            value: "taskApplyType",
          },
        ],
      };
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          this.list = JSON.parse(data.items[0].propDesc);
          this.ruleForm.type = data.items[0].propValue;
          this.id2 = data.items[0].id;
        })
        .catch()
        .finally();
    },
    //获取用户端钱包最大/最小金额
    getList5() {
      let param = {
        page: 1,
        pageSize: 99999,
        queryParams: [
          {
            name: "prop_name",
            type: "input",
            value: "customWithdrawConfigKey",
          },
        ],
      };
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          let obj = JSON.parse(data.items[0].propValue);
          obj.range = (Number(obj.range) * 100).toFixed(2);
          this.ruleForm.customWithdraw = obj;
          this.id0 = data.items[0].id;
          this.id5 = data.items[0].id;
        })
        .catch()
        .finally();
    },
    //获取保安端钱包最大/最小金额
    getList6() {
      let param = {
        page: 1,
        pageSize: 99999,
        queryParams: [
          {
            name: "prop_name",
            type: "input",
            value: "bodyguardWithdrawConfigKey",
          },
        ],
      };
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          let obj = JSON.parse(data.items[0].propValue);
          obj.range = (Number(obj.range) * 100).toFixed(2);
          this.ruleForm.bodyguardWithdraw = obj;
          this.id6 = data.items[0].id;
          this.id1 = data.items[0].id;
        })
        .catch()
        .finally();
    },
    //获取审核方式
    getList7() {
      let param = {
        page: 1,
        pageSize: 99999,
        queryParams: [
          {
            name: "prop_name",
            type: "input",
            value: "bodyguardAuthAutoPower",
          },
        ],
      };
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          this.radioList = JSON.parse(data.items[0].propDesc);
          this.ruleForm.radio = data.items[0].propValue;
          this.id7 = data.items[0].id;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.boxItem {
  border: 1px solid #dcdfe6;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 20px;
}
.boxTitle {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}
/* /deep/ .el-form-item__content {
  display: block;
  -webkit-box-orient: unset;
  -webkit-box-direction: unset;
  -webkit-box-flex: unset;
  -webkit-box-pack: unset;
  -webkit-box-align: unset;
} */
</style>
